import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {ValidationService} from "../../services/validation.service";
import {Conf} from "../../settings/config";
import {AuthServices} from "../../services/auth.service";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LoginComponent} from "../login/login.component";

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html'
})
export class ResetComponent implements OnInit {

  resetForm: FormGroup;

  error = {
    username: '',
    email: '',
    password: '',
    login: '',
  };
  reset_key;

  constructor(private authService: AuthServices,
              private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private fb: FormBuilder,
              private http: HttpClient,
              public _auth: AuthService) {
    this.resetForm = fb.group({
      'password': [null, [Validators.required, ValidationService.passwordValidator]],
      'repeat_password': [null, [Validators.required, ValidationService.passwordValidator]],
    });
  }

  ngOnInit() {
  }


  clickSetNewPassword() {
    this.http.post(Conf.API_URL + '/auth-users/reset-password/' + this.reset_key + '/', {
      password: this.resetForm.value.password,
      repeat_password: this.resetForm.value.repeat_password,
    }).subscribe(
        data => {
          this.openLogin()
        },
        error => {
          var this_e = this;
          $.each(error.error, function (index, value) {
            if (value[0] == 'Token is not valid.') {
              $('#reset_token_error').show()
            } else {
              if (value[0] == 'This field may not be null.') {
                value[0] = 'This field is required'
              }
              this_e.error[index] = value[0];
            }

          });
        }
    );
  }

  closePopup() {
    this.error = {
      username: '',
      email: '',
      password: '',
      login: '',
    };
    this.activeModal.close();
  }

  openLogin() {
    this.closePopup();
    this.modalService.open(LoginComponent, {size: "sm"});
  }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/dialogs/reset/reset.component.ts